const ParserEngineParsedResult = {
  keyFields: ['documentId']
};

export default ParserEngineParsedResult;
